import { useTranslation } from 'react-i18next';
import { PageHeader } from '@/components/Header/Page/PageHeader';
import { BreadcrumbList } from '@/components/Breadcrumbs/BreadcrumbList';
import { BreadcrumbItem } from '@/components/Breadcrumbs/BreadcrumbItem';
import { EngineCorrectionModeration } from '@/components/Common/Moderation/EngineCorrectionModeration';

export const EngineCorrectionPage = () => {
  const { t } = useTranslation('engineCorrection');

  return (
    <>
      <PageHeader
        backToLink="/moteur-de-correction-liste"
        title={t('common:engineCorrection')}
        headingElement={
          <BreadcrumbList>
            <BreadcrumbItem
              text={t('elementList')}
              linkTo="/moteur-de-correction-liste"
            />
            <BreadcrumbItem text={t('elementToModerate')} active />
          </BreadcrumbList>
        }
      />
      <EngineCorrectionModeration />
    </>
  );
};
